import { __awaiter } from "tslib";
import { BaseService } from "../../base";
export class FailedJobService extends BaseService() {
    static get entity() {
        return "failed_job";
    }
    static get responseName() {
        return "failed_job";
    }
    static filterFailedJobs(params, page = 1) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.submit({
                method: "post",
                path: `filter?page=${page}`,
                data: params,
                showFullResponse: true,
            });
            return response.data;
        });
    }
    static getRetryJob(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `retry_job`,
                data: data,
            });
        });
    }
}
